import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7dbfdba6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"font-family":"fangsong"},
  class: "lh30 fz16 c333"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"text-align":"center"} }, "用户信息及隐私权规定", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.1pt","background":"white"}
}, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createTextVNode("第一条 提示条款"),
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, [
  /*#__PURE__*/_createTextVNode(" 感谢您选择云南启航就业服务平台（以下简称“启航就业平台”）！您的信任是启航就业平台提供服务的不竭动力，亦是促进平台持续提升优质服务的动力源泉。启航就业平台深知用户信息安全及个人隐私的重要性，平台将按照现行法律法规的规定，积极采取安全保障措施，确保用户的信息安全。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, [
  /*#__PURE__*/_createTextVNode(" 鉴于此，启航就业平台制定本《用户信息及隐私权规定》（以下简称“本规定”），本规定适用于启航就业平台向您提供的所有服务，"),
  /*#__PURE__*/_createElementVNode("strong", null, "在您使用"),
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createTextVNode("启航就业平台"),
    /*#__PURE__*/_createElementVNode("strong", null, "的各项服务前，请务必仔细阅读并充分理解本规定")
  ]),
  /*#__PURE__*/_createElementVNode("b", null, "，希望您可以根据自己的理解做出合适的选择。"),
  /*#__PURE__*/_createElementVNode("strong", null, "您一旦选择使用"),
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createTextVNode("启航就业平台"),
    /*#__PURE__*/_createElementVNode("strong", null, "服务，即视为对本规定的接受和认可。")
  ]),
  /*#__PURE__*/_createElementVNode("b")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.1pt","background":"white"}
}, [
  /*#__PURE__*/_createElementVNode("b", null, "第二条 用户信息及隐私内容")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" 您使用启航就业平台服务，启航就业平台将收集以下必要的相关个人信息，以及部分您可以选择提供的个人信息。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, [
  /*#__PURE__*/_createTextVNode(" 1.身份识别信息：使用启航就业平台求职时，在账号注册、个人信息认证等服务中，会收集包括但不限于账号、姓名、公民身份号码、年龄、住址、照片、联系地址、电话号码、个体特征等个人信息。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, [
  /*#__PURE__*/_createTextVNode(" 2.企业用户信息：企业使用启航就业平台招聘时，包括但不限于公司营业执照、公司注册账号、组织名称、工商登记信息、实际经营者身份信息等信息；"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, [
  /*#__PURE__*/_createTextVNode(" 3.求职信息：主要为求职者的简历信息及工作信息，包括您工作单位的名称、职位头衔，企业邮箱、工牌、在职证明等；工作经历（开始工作时间、公司名称、担任职务、在职时间段、工作内容描述）、教育经历（毕业学校、学历、在校时间段、在校经历描述）、联系方式（微信、手机号码、电子邮箱）、工作期望（期望城市、期望薪资、期望行业、期望岗位）等简历信息。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, [
  /*#__PURE__*/_createTextVNode(" 4.启航就业平台操作信息，包括但不限于"),
  /*#__PURE__*/_createElementVNode("span", null, "IP"),
  /*#__PURE__*/_createTextVNode("地址、设备型号、设备标识符、操作系统版本等； ")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, " 5.支付信息：选择增值服务时，包括但不限于用户的支付时间、支付金额、购买明细、订单号、支付工具、微信代付时访问该微信好友支付信息、支付宝代付时访问该支付宝好友支付信息、银行账户及支付账户等； ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, [
  /*#__PURE__*/_createTextVNode(" 6.与位置匹配服务时，申请获取用户的位置信息（"),
  /*#__PURE__*/_createElementVNode("span", null, "GPS"),
  /*#__PURE__*/_createTextVNode("定位）；经用户授权同意后，再获取用户的位置权限，例如用户所在的城市、地区等。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, [
  /*#__PURE__*/_createTextVNode(" 7.推荐就业岗位服务时，会通过用户填写的求职期望、工作经历，历史搜索记录等信息，以及您同意平台获取用户的位置信息，结合用户的操作记录（如搜索、浏览、关注、收藏及开聊）形成用户的关键词，平台根据关键词为用户推送相关招聘信息或求职用户以及将用户推荐给其他招聘用户或求职用户。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" 8.开聊"),
  /*#__PURE__*/_createElementVNode("span", null, "/"),
  /*#__PURE__*/_createTextVNode("面试"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" 求职用户或招聘用户在平台提供的线上联系窗口进行线上沟通时，根据双方沟通意向，可能需要交换联系方式或其他个人信息，由双方自行决定，但平台在必要时有获取的权利。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"24.0pt"} }, " 9.其他根据具体服务需要而收集的用户信息，包括但不限于用户对平台或服务的意见、建议、用户曾经使用或经常使用习惯等信息。 ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.1pt","background":"white"}
}, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createTextVNode("第三条 个人信息使用"),
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, [
  /*#__PURE__*/_createTextVNode(" 1.启航就业平台收集及使用用户的个人信息与平台提供的服务相匹配，遵循合法、正当、必要的原则。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, [
  /*#__PURE__*/_createTextVNode(" 2.若用户认为平台收集及使用的个人信息与平台提供的服务无关，您可以到平台沟通渠道反映或不使用平台服务，平台将不再继续收集和使用您的相关信息，但也无法为您提供与这些授权所对应的相关功能。上述权限的关闭决定并不会影响此前基于您的授权所进行的个人信息的处理。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, " 3.本平台不会向任何人出售或提供用户信息，应相关国家机关或法律法规规定或事先得到用户许可的除外。 ", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, " 4.启航就业平台不允许任何第三方未经用户同意，收集、编辑、出售或者无偿传播用户信息。若有用户从事前述活动，本平台有权立即终止与该用户的服务，视情况采取将账号拉入黑名单等措施，并依法追究其责任。应相关国家机关或法律法规规定或事先得到用户许可的除外。 ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, " 5.启航就业平台服务期间，用户对获取的启航就业平台的所有信息，具有保密义务，不得作有损他人权益的行为；若用户违法泄露信息的，启航就业平台台将有权采取相应措施。 ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, [
  /*#__PURE__*/_createTextVNode(" 6."),
  /*#__PURE__*/_createElementVNode("strong", null, "有下列情形下之一的，"),
  /*#__PURE__*/_createTextVNode("启航就业平台"),
  /*#__PURE__*/_createElementVNode("strong", null, "有权共享、移交、披露用户部分或全部信息：")
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "1"),
  /*#__PURE__*/_createTextVNode("）经用户同意共享、移交、披露的； ")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "2"),
  /*#__PURE__*/_createTextVNode("）与关联方、合作方可以共享、移交、披露启航就业平台收集的个人信息，包括但不限于、服务平台或服务提供商、软硬件"),
  /*#__PURE__*/_createElementVNode("span", null, "/"),
  /*#__PURE__*/_createTextVNode("系统服务提供商及其他的合作开发主体或关联主体。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "2"),
  /*#__PURE__*/_createTextVNode("）用户在使用启航就业平台过程中涉及侵权纠纷，有第三人主张权利，平台审核处理后，将"),
  /*#__PURE__*/_createElementVNode("strong", null, "通过平台通知方式告知用户，用户提交相关证明材料后享有申诉的权利；")
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "3"),
  /*#__PURE__*/_createTextVNode("）根据法律法规规定，或者应行政、司法等机关的要求，向第三方或者行政、司法等机关披露的； ")
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "4"),
  /*#__PURE__*/_createTextVNode("）因用户违反国家有关法律或者网站规定，需要披露的； ")
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "5"),
  /*#__PURE__*/_createTextVNode("）因提供用户所要求服务，必须向第三方提供用户信息的； ")
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "6"),
  /*#__PURE__*/_createTextVNode("）用于预防、调查用户涉及欺诈、危害安全、违法或违反与启航就业平台或其他关联方协议、规定或规则、违反公序良俗行为的； ")
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "7"),
  /*#__PURE__*/_createTextVNode("）在遵循个人信息、隐私权保护以及其他相应的安全保密措施的前提下，将用户个人信息提供给相关合作方，以便其根据指令处理相关信息的； ")
], -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "8"),
  /*#__PURE__*/_createTextVNode("）为促成服务或协助争议解决，有权共享用户信息，促成服务或处理用户间及用户与其他主体间纠纷的； ")
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "9"),
  /*#__PURE__*/_createTextVNode("）根据法律法规规定及商业惯例，平台需要接受第三方审计或尽职调查时，可向其提供用户相关信息； ")
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "10"),
  /*#__PURE__*/_createTextVNode("）平台不会将用户的信息转让给任何法人、组织和个人，但在启航就业平台与其他主体发生合并、分立、资产或业务的收购或出售等交易或破产清算时，如涉及到用户信息移交的，平台有权要求承继的运营公司受本规定的约束。 ")
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "11"),
  /*#__PURE__*/_createTextVNode("）其它根据法律法规及政策或者启航就业平台规定应当披露的情形。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, " 7.公开信息 ", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, [
  /*#__PURE__*/_createTextVNode(" 公开信息是指用户自行公开或分享的信息，可以在使用和未使用启航就业平台服务期间查看或访问。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, [
  /*#__PURE__*/_createTextVNode(" 公开信息主要涉及依法律法规规定必须公开的，用户自愿公开的，他人经用户许可可以获取的，平台要求公开的信息等。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, [
  /*#__PURE__*/_createTextVNode(" 8.第三方平台收集使用个人信息的情形"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"24.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "1"),
  /*#__PURE__*/_createTextVNode("）为保障我们客户端的稳定运行、功能实现，使您能够使用和体验更丰富的服务及功能，我们的应用中会嵌入授权合作伙伴或其他应用程序。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"24.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "2"),
  /*#__PURE__*/_createTextVNode("）我们会对授权合作伙伴进行严格的安全检测，并约定严格的数据保护措施，令其按照本规定以及其他任何相关的保密和安全措施来处理个人信息。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"24.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "3"),
  /*#__PURE__*/_createTextVNode("）当您通过本平台接入的第三方服务时，您的信息将适用该第三方的隐私政策，建议您在接受相关服务前阅读并确认理解相关协议。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"24.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "4"),
  /*#__PURE__*/_createTextVNode("）对我们与之共享用户信息的公司、组织和个人，我们会与其签署严格的保密协议以及信息保护约定，要求他们按照我们的说明、本隐私权规定以及其他任何相关的保密和安全措施来处理用户信息。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" 9.例外情形"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" 在以下情形中，共享、移交、公开披露您的个人信息无需事先征得您的授权同意："),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "1"),
  /*#__PURE__*/_createTextVNode("）与国家安全、国防安全直接相关的；"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "2"),
  /*#__PURE__*/_createTextVNode("）与公共安全、公共卫生、重大公共利益直接相关的；"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "3"),
  /*#__PURE__*/_createTextVNode("）与犯罪侦查、起诉、审判和判决执行等直接相关的；"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "4"),
  /*#__PURE__*/_createTextVNode("）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "5"),
  /*#__PURE__*/_createTextVNode("）您自行向社会公众公开的个人信息；"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "6"),
  /*#__PURE__*/_createTextVNode("）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "7"),
  /*#__PURE__*/_createTextVNode("）根据个人信息主体要求签订和履行合同所必需的；"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "8"),
  /*#__PURE__*/_createTextVNode("）用于维护所提供的产品或服务的安全稳定运行所必需的，包括发现、处置产品或服务的故障；"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "9"),
  /*#__PURE__*/_createTextVNode("）法律法规规定的其他情形。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "10"),
  /*#__PURE__*/_createTextVNode("）根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。 ")
], -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createTextVNode("特别提示：使用启航就业平台服务时，用户不可避免要向他人或企业用户披露己方的相关信息，如联络方式或者邮寄地址、简历信息等。请用户妥善保护自己的信息，仅在必要的情形下向他方提供。"),
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"27.75pt"} }, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createTextVNode("用户也可以通过平台的服务建立联系和相互分享。当用户通过平台的服务创建交流或分享时，可以自主选择沟通或分享的对象作为能够看到用户的联络方式、交流信息或分享内容等信息的第三方。"),
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.1pt","background":"white"}
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "如用户发现自己的信息泄漏，尤其是账户或密码发生泄露，请立即联络"),
  /*#__PURE__*/_createTextVNode("启航就业平台"),
  /*#__PURE__*/_createElementVNode("strong", null, "客服，"),
  /*#__PURE__*/_createTextVNode("启航就业平台"),
  /*#__PURE__*/_createElementVNode("strong", null, "将及时采取应对措施。")
], -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.1pt","background":"white"}
}, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createTextVNode("第四条 个人信息安全保护"),
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"24.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 1.组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性，身份核验等程序设置，最大限度保障您的身份信息、服务信息等的安全。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"24.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 2.平台会采取合理可行的措施，尽力避免收集无关的个人信息。我们只会在达成本规定所述目的所需的期限内保留您的个人信息（除非法律有强制的存留要求或双方另有约定）。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"24.0pt"} }, " 3.平台在服务过程中，如果发现您提供的信息、位置信息等信息之间存在冲突或异常时，平台根据自身系统设置工能，将采取实时获取、更新您的设备标识信息与位置信息，或其他保障您权利的行为。 ", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"justify","text-indent":"24.1pt"} }, [
  /*#__PURE__*/_createElementVNode("strong", null, "4."),
  /*#__PURE__*/_createTextVNode("用户在使用本平台服务时，请妥善保护相关信息。"),
  /*#__PURE__*/_createElementVNode("strong", null, "若用户发现自己信息泄漏，尤其是用户账号及密码发生泄漏，请立即联络本平台客服，以便及时采取应对措施。"),
  /*#__PURE__*/_createElementVNode("strong")
], -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.1pt","background":"white"}
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "5."),
  /*#__PURE__*/_createTextVNode("使用启航就业平台服务时，建议您不要使用非启航就业平台推荐的通信方式发送您的信息。您可以通过我们的服务建立联系和相互分享。"),
  /*#__PURE__*/_createElementVNode("strong")
], -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.1pt","background":"white"}
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "6."),
  /*#__PURE__*/_createElementVNode("strong", null, "启航就业平台，具有一般网络平台数据安全系统，定期会进行专人维护，采取符合业界标准、合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。但非启航就业平台原因导致用户信息泄漏的，启航就业平台不承担任何责任。"),
  /*#__PURE__*/_createElementVNode("strong")
], -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.1pt","background":"white"}
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "7."),
  /*#__PURE__*/_createElementVNode("strong", null, "投诉、审诉的权利，"),
  /*#__PURE__*/_createTextVNode("启航就业平台会设置特定的沟通渠道（包括客服电话、邮箱地址等），用于处理您的投诉举报、申诉，确保信息安全意见得到有效反馈。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" 8.您在使用启航就业平台服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息，如您在评论、沟通时选择上传包含个人信息的资料。请您更加谨慎地考虑，是否在使用启航就业平台的服务时共享甚至公开分享相关信息。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, " 9.您使用启航就业平台服务过程中，平台会根据具体情况采取的其他安全保护措施。 ", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.1pt","background":"white"}
}, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createTextVNode("第五条 用户的权利"),
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" 按照中国相关的法律、法规，用户可以对自己的个人信息行使以下权利："),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.1pt","background":"white"}
}, [
  /*#__PURE__*/_createElementVNode("b", null, "1."),
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createTextVNode("访问和修改您的个人信息"),
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "1"),
  /*#__PURE__*/_createTextVNode("）用户可自行决定访问和修改您的个人信息"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "2"),
  /*#__PURE__*/_createTextVNode("）如果访问或修改受阻，用户可以通过本规定公布的联系方式与平台联系。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "3"),
  /*#__PURE__*/_createTextVNode("）用户发现我们处理的关于个人信息有错误时，有权对错误或不完整的信息作出更正或更新，但需符合平台设置的身份核验或其他程序。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.1pt","background":"white"}
}, [
  /*#__PURE__*/_createElementVNode("b", null, "2."),
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createTextVNode("删除您的个人信息"),
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" 在以下情形中，用户可以向平台提出删除个人信息的请求，用户可以通过本规定公布的联系方式随时与平台联系："),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "1"),
  /*#__PURE__*/_createTextVNode("）认为平台侵犯了用户个人信息或隐私权的。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "2"),
  /*#__PURE__*/_createTextVNode("）认为平台存在违反法律法规规定或与用户的约定，公开披露个人信息等。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "3"),
  /*#__PURE__*/_createTextVNode("）用户注销了启航就业平台帐号、卸载或者不再使用平台的服务。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "4"),
  /*#__PURE__*/_createTextVNode("）平台停止对用户提供服务。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.1pt","background":"white"}
}, [
  /*#__PURE__*/_createElementVNode("b", null, "3. "),
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createTextVNode("改变授权范围"),
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" (1)改变或撤回敏感信息权限"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" 您可以在设备本身操作系统中关闭地理位置、通讯录、摄像头、麦克风等权限改变同意范围或撤回您的授权。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" (2)拒绝接受推送及营销信息"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" 注：特定的业务功能和服务将需要您的信息才能完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也将不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的同意或授权而开展的个人信息处理。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.1pt","background":"white"}
}, [
  /*#__PURE__*/_createElementVNode("b", null, "4."),
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createTextVNode("注销您的账号"),
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" 用户可根据平台的程序，主动注销账号。注销后平台将停止为用户提供产品或服务，并根据法律的要求删除用户的个人信息，或对其进行匿名化处理。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" 5.其他平台设置的其他权利。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.1pt","background":"white"}
}, [
  /*#__PURE__*/_createElementVNode("b", null, "第六条 未成年人的个人信息保护")
], -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" 因启航就业平台系就业招聘平台，根据《中华人民共和国劳动法》《中华人民共和国劳动合同法》等相关法律法规的规定，启航就业平台非常重视对未成年人信息的保护，并拒绝年龄未满"),
  /*#__PURE__*/_createElementVNode("span", null, "18"),
  /*#__PURE__*/_createTextVNode("周岁的用户（年满"),
  /*#__PURE__*/_createElementVNode("span", null, "16"),
  /*#__PURE__*/_createTextVNode("周岁未满"),
  /*#__PURE__*/_createElementVNode("span", null, "18"),
  /*#__PURE__*/_createTextVNode("周岁的未成年人如果以自己的劳动收入为主要的生活来源除外，且从事的劳动需符合法律法规的规定）使用启航就业平台。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.1pt","background":"white"}
}, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createTextVNode("第七条 个人信息跨境转移"),
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" 用户的个人信息将只存储在位于中国的服务器上，用户的信息将不会被平台主动传输到境外。用户需要知晓，启航就业平台上的招聘方包含跨国公司和境外集团，其可能在境外使用启航就业平台、"),
  /*#__PURE__*/_createElementVNode("span", null, "App"),
  /*#__PURE__*/_createTextVNode("、小程序、将您的简历发送境外等，具体实践请见各该等企业的隐私政策。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.1pt","background":"white"}
}, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createTextVNode("第八条 规定的更新"),
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" 启航就业平台有权适时对本规定及平台其他规定进行修订，当条款发生变更时，启航就业平台会在用户登录及版本更新时通过公告或系统消息等方式告知用户。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" 因本规定及平台其他规定内容变更，启航就业平台将在平台依法公示。公示期满即生效，原启航就业平台用户继续使用平台服务的，即视为认可变更后的规定，接受其约束。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.1pt","background":"white"}
}, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createTextVNode("第九条"),
    /*#__PURE__*/_createElementVNode("span", null, "  "),
    /*#__PURE__*/_createTextVNode("争议解决"),
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" 本规定及启航就业平台其他规定共同构成您使用启航就业平台服务的基本协议文件。本规定适用中华人民共和国现行法律法规。与本规定相关的争议，如果您对平台的回复或解决方案不满意，需要通过法律途径解决的，应将该争议提交至昆明仲裁委，其仲裁裁决是终局的。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.1pt","background":"white"}
}, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createTextVNode("第十条 联系平台"),
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1))
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" 1.本规定的最终解释权归属启航就业平台及其运营公司。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"text-align":"left","text-indent":"24.0pt","background":"white"}
}, [
  /*#__PURE__*/_createTextVNode(" 2.若对本规定有任何疑问意见或建议，您可通过启航就业平台客服电话： 4008061633或邮箱：a4008061633@163.com 与平台联系。"),
  /*#__PURE__*/_createElementVNode("span", null, " ")
], -1))
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  align: "left",
  style: {"margin-left":"0cm","text-align":"left","background":"white"}
}, "   ", -1))
const _hoisted_103 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9,
  _hoisted_10,
  _hoisted_11,
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15,
  _hoisted_16,
  _hoisted_17,
  _hoisted_18,
  _hoisted_19,
  _hoisted_20,
  _hoisted_21,
  _hoisted_22,
  _hoisted_23,
  _hoisted_24,
  _hoisted_25,
  _hoisted_26,
  _hoisted_27,
  _hoisted_28,
  _hoisted_29,
  _hoisted_30,
  _hoisted_31,
  _hoisted_32,
  _hoisted_33,
  _hoisted_34,
  _hoisted_35,
  _hoisted_36,
  _hoisted_37,
  _hoisted_38,
  _hoisted_39,
  _hoisted_40,
  _hoisted_41,
  _hoisted_42,
  _hoisted_43,
  _hoisted_44,
  _hoisted_45,
  _hoisted_46,
  _hoisted_47,
  _hoisted_48,
  _hoisted_49,
  _hoisted_50,
  _hoisted_51,
  _hoisted_52,
  _hoisted_53,
  _hoisted_54,
  _hoisted_55,
  _hoisted_56,
  _hoisted_57,
  _hoisted_58,
  _hoisted_59,
  _hoisted_60,
  _hoisted_61,
  _hoisted_62,
  _hoisted_63,
  _hoisted_64,
  _hoisted_65,
  _hoisted_66,
  _hoisted_67,
  _hoisted_68,
  _hoisted_69,
  _hoisted_70,
  _hoisted_71,
  _hoisted_72,
  _hoisted_73,
  _hoisted_74,
  _hoisted_75,
  _hoisted_76,
  _hoisted_77,
  _hoisted_78,
  _hoisted_79,
  _hoisted_80,
  _hoisted_81,
  _hoisted_82,
  _hoisted_83,
  _hoisted_84,
  _hoisted_85,
  _hoisted_86,
  _hoisted_87,
  _hoisted_88,
  _hoisted_89,
  _hoisted_90,
  _hoisted_91,
  _hoisted_92,
  _hoisted_93,
  _hoisted_94,
  _hoisted_95,
  _hoisted_96,
  _hoisted_97,
  _hoisted_98,
  _hoisted_99,
  _hoisted_100,
  _hoisted_101,
  _hoisted_102
]
const _hoisted_104 = {
  style: {"font-family":"fangsong"},
  class: "lh30 fz16 c333"
}
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"text-align":"center"} }, "云南启航就业服务平台用户协议", -1))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 亲爱的用户，在您成为云南启航就业服务平台（以下简称“本平台”或“启航就业”）注册用户以及享受云南启航就业服务平台提供的服务之前，请您认真阅读《云南启航就业服务平台用户协议》（以下简称“本协议”），充分的了解本协议项下的全部服务内容以及您将享有的所有权利和须承担的所有义务。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 您一旦点击已阅读知晓选项完成注册认证，并开始使用本平台服务，即表示您已经确认并接受了本协议项下的全部条款，本协议自您完成本平台注册之日起即生效，届时本协议将完整约束您使用本平台的各项直接行为及关联行为，对于您未来可能出现的违反本协议项下约定的所有情形，您将按照本协议有关条款承担不利后果及法律责任。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 本协议系由您（以下简称“用户”或“您”）与本平台授权运营方上海思佩驰科技有限公司（以下简称“我们”）针对我们提供的本平台软件进行相关权利义务及责任的明确为签订目的。请您在注册、使用启航就业之前，认真阅读以下条款。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.1pt"} }, [
  /*#__PURE__*/_createElementVNode("b", null, "第一条 概述")
], -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 1.本协议全面约定了平台服务、用户行为、权利与义务等内容。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 2.使用启航就业的用户，应遵守国家法律、法规、规章等规范性文件及本平台的规定。对任何涉嫌违反法律、法规、规章及平台相关规定的行为，本平台有权直接依法依规处理，并有权追究用户的法律责任。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 3.本平台作为平台信息和服务的提供方，用户的行为仅代表用户本人，若因用户的个人行为导致权益受侵害以及其他不利后果的，由其自行承担，与本平台无关。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 4.除按照相关法律法规规定不能转让、交易或各方另有约定外，凡在本平台上进行的行为，其中涉及的知识产权及相关权利需依法依规确定。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 5.本平台及运营公司有权对本协议进行独立解释，并决定是否施行、适用。同时，本平台有权对本协议进行修改和补充，按法律相关规定予以公示。公示期满不接受修改后本协议的原用户，应当立即停止使用本平台的相关服务，公示期满注册的新用户及适用修改后的服务协议。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 7.启航用户包括招聘用户和求职用户。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "1"),
  /*#__PURE__*/_createTextVNode("）招聘用户：经启航就业平台注册的企业、事业单位、其他组织及个人，可在在启航就业平台发布招聘需求的主体。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "2"),
  /*#__PURE__*/_createTextVNode("）求职用户：经启航就业平台注册的自然人，包括但不限于就业局重点监测户人员、低保家庭人员、残疾人、特困供养人员、易致贫边缘户人员等求职主体，可在启航就业注册后，享受启航就业平台提供的服务。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 8.启航就业用户对本协议或相关协议有疑问的，请及时与平台联系。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.1pt"} }, [
  /*#__PURE__*/_createElementVNode("b", null, "第二条 用户注册")
], -1))
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 1.申请注册成为启航就业的用户应同时满足下列全部条件：在注册之日以及此后使用启航就业服务期间必须以招聘或求职为目的；在注册之日必须年满"),
  /*#__PURE__*/_createElementVNode("span", null, "18"),
  /*#__PURE__*/_createTextVNode("周岁（年满"),
  /*#__PURE__*/_createElementVNode("span", null, "16"),
  /*#__PURE__*/_createTextVNode("周岁未满"),
  /*#__PURE__*/_createElementVNode("span", null, "18"),
  /*#__PURE__*/_createTextVNode("周岁的未成年人如果以自己的劳动收入为主要的生活来源除外，且从事的劳动需符合法律法规的规定）。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 2.注册时，按平台要求提供本人真实、准确、最新及完整的资料；如注册并认证成为招聘用户，应保证及时更新本人提供的“单位名称、职务或岗位信息、企业邮箱”等相关授权信息及材料，并确保前述授权的真实性；招聘用户应保证其职务行为，包括但不限于发布招聘信息、与求职者沟通等均在使用本平台期间持续有效；通过认证的用户应保持其招聘账号与对应的授权单位具有唯一性。如注成为求职用户，应提供“个人基本信息、学籍学历、工作履历”等信息及相关证书或证明材料，并对前述信息、材料的完整性、真实性及有效性负责。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 3.若用户提供任何错误、不实或不完整的资料，或我们有理由怀疑资料为错误、不实或不完整及违反用户注册条款的，或我们有理由怀疑其用户资料、言行等有悖于严肃、健康、纯洁的招聘求职环境或违反启航就业其他规定的，我们有权修改用户的注册昵称、个人说明、发布的信息等，或暂停或终止该用户使用其账号及终止提供启航就业提供的全部或部分服务（包括免费、付费业务）。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 4.若用户故意提供虚假的个人身份信息、公司信息或其他信息进行注册，发布虚假招聘信息或者求职信息的，视为严重违反本协议，我们有权暂停或终止该用户账号并停止提供服务。虚假注册、发布虚假信息给我们或启航就业平台造成经济、名誉等任何损失的，我们将追究该用户的法律责任。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.1pt"} }, [
  /*#__PURE__*/_createElementVNode("b", null, "第三条 用户账号、密码及安全")
], -1))
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 1.用户完成注册后，用户将有专属密码及账号。用户有义务保证密码及账号的安全，账号不得出借、转让以及授权第三人进行任何信息发布、传递及其他非用户本人使用的行为。用户应对利用该密码及账号所进行的一切活动负全部责任，包括任何使用启航就业包括但不限于上载、张贴、发送电子邮件或任何其它方式传送的资讯、资料、文字、软件、音乐、音讯、照片、图形、视讯、信息或其它资料，无论系公开还是私下传送，均由内容提供、发布、传递者承担相关法律责任及不利后果。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 2.用户的密码或账号遭到非本人登录或使用的情形，或者发生其他任何安全问题时，用户应立即通知我们。由于用户使用不当或者其他非因我方原因导致的账号、密码泄漏，进而导致其资料、信息泄漏的，由用户自行承担一切不利后果。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 3.用户不得将账号主动告知任意第三方或提供给任意第三方进行使用。如因此造成用户隐私泄露或启航就业损失的，用户应当承担全部赔偿责任。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.1pt"} }, [
  /*#__PURE__*/_createElementVNode("b", null, "第四条 服务说明")
], -1))
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 1.启航就业依据法律法规为用户提供网络服务，包括在线及离线的相关业务。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 2.启航就业信息发布及求职发布信息的平台，招聘主体可根据己方的招聘需求按本平台的要求发布招聘信息；求职主体根据自己的求职需求寻找招聘主体，包括但不限于投递简历。具体包括注册、登录、企业认证、账号管理、发布招聘、求职信息、邀约面试、申请面试以及其他通过启航就业账号在本平台所进行的一切行为。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 3.启航就业提供招聘主体与求职主体联系的途径和方式，比如私信、面试。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 4.启航就业在提供网络服务时，可能会对部分服务内容采取有价使用的方式进行提供，在此情况下，我们会在平台相关页面上向客户作出明确的提示，用户可自由选择是否使用，如用户拒绝支付该等费用，则不能使用对应付费内容。用户应认真阅读其他相关协议，如用户购买付费业务，则视为接受本平台服务项下的所有条款。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 5.基于风控策略等的需要，启航就业可能要求部分用户补充提供材料（包括但不限于企业资质证明、承诺书、业务协议、个人身份证明材料、个人学历学位证书、资格证书、离职证明、学历存放证明等），具体要求将在平台相关页面上做明确展示。如用户拒绝提供前述材料，若所需服务系特定服务，则启航就业有权视情况暂停或终止向该用户提供部分或全部服务。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 6.为落实"),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "http://www.mohrss.gov.cn/xxgk2020/fdzdgknr/zcfg/bmgz/202012/t20201223_406512.html",
      target: "_blank"
    }, "《网络招聘服务管理规定》")
  ]),
  /*#__PURE__*/_createTextVNode("载明的法定义务，启航就业可能会不定期对部分招聘用户的企业地址、招聘授权等相关信息进行真实性审查以及更新核验。审查过程中，招聘用户应配合启航就业工作人员补充相关资料（包括但不限于营业执照、资质证书"),
  /*#__PURE__*/_createElementVNode("span", null, "/"),
  /*#__PURE__*/_createTextVNode("相关业务协议、授权书、被授权人身份证信息、办公地点租赁协议"),
  /*#__PURE__*/_createElementVNode("span", null, "/"),
  /*#__PURE__*/_createTextVNode("水电费记录等），并允许启航就业工作人员对其企业"),
  /*#__PURE__*/_createElementVNode("span", null, " LOGO"),
  /*#__PURE__*/_createTextVNode("、办公环境进行审查及拍照备案"),
  /*#__PURE__*/_createElementVNode("span", null, "("),
  /*#__PURE__*/_createTextVNode("具体要求见网页说明或“消息”通知"),
  /*#__PURE__*/_createElementVNode("span", null, ")"),
  /*#__PURE__*/_createTextVNode("。若用户拒绝，启航就业将视情况决定是否暂停或终止为该用户提供部分或全部的招聘、求职服务（包括付费服务）。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 7.对于利用启航就业进行非法活动，或其言行（无论线上或者线下的）背离严肃招聘目的或其他违反法律禁止性/强制性规定的，我们将严肃处理，包括但不限于将其列入黑名单、合法的向投诉者、有关主管机关披露该等行为的具体情况、删除或封禁用户账号等处罚措施，给启航就业及我们造成经济或者名誉等任何损失的，我们将追究其法律责任。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 8.启航就业有权通过网站公告、拨打电话、发送短信或电子邮件等方式，告知用户启航就业服务相关的更新内容，除系统通知或重要信息外，用户可以通过启航就业提供的方式选择不接收上述信息。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 9.启航就业的增值服务只在本平台上或由我们直接对外出售或者赠送使用权，用户不得在任何其他平台或渠道购买启航就业的增值服务，因此造成的任何损失由用户自行承担，启航就业因此遭受损失的，平台可以向用户追偿。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 10.用户仅能通过本平台使用启航就业相关服务，任何情况均不得通过其他第三方工具或运营平台获取启航就业服务，包括但不限于通过第三方平台或软件登录启航就业账号、发布职位、浏览职位、收发简历等（启航就业微信小程序、公众号除外）。如因用户使用第三方软件导致启航就业平台任意信息泄漏的，启航就业不承担任何责任，且用户还应承担由此给启航就业及我们造成的损失。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.1pt"} }, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createTextVNode("第五条 有限责任条款"),
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1))
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 1.我们作为唯一官方授权运营方，将致力为用户提供高质量的服务，但不保证满足用户全部的要求和期望，我们提供的服务除违反本协议项下明确约定外。用户主张包括但不限于体验感、服务流程、服务效果等未达到心理预期的，或用户因非我方过错而无法使用启航就业服务，我们不承担任何违约责任。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 2.对于用户通过启航就业公司提供的服务发布的内容，我将依法按照国家有关规定严格审查，但在尽到合理努力的前提下，非因我方原因，仍无法完全控制经由软件"),
  /*#__PURE__*/_createElementVNode("span", null, "/"),
  /*#__PURE__*/_createTextVNode("网站服务传送的内容的情形下，我们不承担任何法律责任及不利后果。在任何情况下，我们均不为用户经由启航就业服务以张贴、发送电子邮件或其它方式传送、传递的任何内容负责。但我们有权在知晓并核实具体情况的前提下，依法停止传输任何前述内容并采取相应行动，包括但不限于暂停用户使用软件"),
  /*#__PURE__*/_createElementVNode("span", null, "/"),
  /*#__PURE__*/_createTextVNode("网站服务的全部或部分，保存有关记录，并根据国家法律法规、相关政策在必要时向有关机关报告并配合有关机关的行动。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 3.对于启航就业提供的各种第三方广告信息、链接、资讯等（如有），启航就业不保证其内容的正确性、合法性或可靠性，相关责任由广告发布方承担；且对于用户经由启航就业服务与广告主进行联系或商业往来，完全属于用户和广告主之间的行为，与我们无关。对于前述商业往来所产生的任何法律责任及不利后果，我们不承担任何责任。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 4.对于用户上传的照片、资料、证件、视频、内容及图片等，在我们已采用相关措施并已尽合理努力完成审核的前提下，非因我方原因包括但不限于技术范畴外而导致的无法获悉、比对等情形，我们不保证用户上传内容的正确性、合法性或可靠性，相关责任由上传上述内容的用户承担。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 5.用户应对启航就业上的其他用户发布的内容自行加以判断，并承担因使用内容而引起的所有风险，包括但不限于因对内容的真实性、完整性、有效性的依赖而产生的风险。我们无法且不会对因前述风险而导致的任何损失或损害承担责任。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 6.是否使用启航就业的下载服务获取任何企业、个人资料应由用户自行考虑并自负风险，因任何资料的下载而导致的用户电脑系统的任何损坏或数据丢失等后果，启航就业不承担任何责任。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 7.对于我们在线上或线下策划、发起、组织或是承办的任何招聘相关的活动（包括但不限于收取费用以及完全公益的活动），我们不对上述招聘效果向用户作出任何保证或承诺，也不担保活动期间用户自身行为的合法性、合理性，且线上、线下活动的相关费用支出成本由决定参与活动的用户自行承担。由此产生的任何对于用户个人或者他人的人身或者是名誉以及其他损害，应由行为实施主体承担责任。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 8.对于用户的投诉，我们将尽合理努力进行核实和处理，但不保证一定能满足投诉者的要求。我们有权决定是否向被投诉者公开投诉内容。对于投诉内容侵犯用户隐私权、名誉权等合法权益的，所有法律责任由投诉者承担，与我们及启航就业无关。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.1pt"} }, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createTextVNode("第六条 用户权利义务"),
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1))
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 1.随时查询及请求阅览，但因极少数特殊情况（如被网站加入黑名单等）无法查询及提供阅览的除外；"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 2.随时请求补充或更正，但因极少数特殊情况（如网站或有关机关为司法程序保全证据等）无法补充或更正的除外；"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 3.随时请求注销启航就业账号。用户注销成功后，我们将根据法律法规的要求尽快删除用户的个人信息或作匿名化处理。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 4.用户应遵守《中华人民共和国民法典》《中华人民共和国著作权法》《中华人民共和国劳动法》《中华人民共和国劳动合同法》《网络信息内容生态治理规定》等相关中国法律法规的规定。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 5.在任何情况下，如果我们有理由认为用户使用启航就业服务过程中的任何行为，包括但不限于用户的任何言论和其它行为违反或可能违反上述法律和法规的任何规定，我们有权在不经任何事先通知的情况下终止向该用户提供服务。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 6.用户承诺在使用启航就业期间，遵守法律法规、社会主义制度、国家利益、公民合法权益、公序良俗和诚实守信等六条底线。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 7.您理解并同意，启航就业仅为用户提供招聘信息分享、传播及获取招聘、求职机会的平台，您必须为自己的注册、认证账号下的一切行为负责，包括您所发表的任何内容以及由此产生的任何后果。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 8.禁止用户在启航就业的网站平台或利用启航就业提供的服务，制作、发送、复制、发布、传播违反国家相关法律法规及本协议、启航就业其他全部关联协议项下禁止的行为："),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 包括但不限于违法犯罪行为、散布谣言，扰乱社会秩序，破坏社会稳定的；散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；侮辱或者诽谤他人，侵害他人合法权益的；发布、传播侵犯任何人的肖像权、名誉权、隐私权、专利权、商标权、著作权、商业秘密的信息或言论的；将病毒或其它计算机代码、档案和程序，加以上载、张贴、发送电子邮件或以其它方式传送的；跟踪或以其它方式骚扰其他用户的；未经合法授权而截获、篡改、收集、储存或删除他人个人信息、电子邮件或其它数据资料，或将获知的此类资料用于任何非法或不正当目的；未能按照本平台的流程、规则进行注册、认证或使用本服务的，违反本服务功能限制或运营策略，或采取任何措施规避前述流程、规则、限制或策略的；利用启航就业账号或本平台服务从事，包括但不限于欺诈、传销、刷流量、好评、违法物品营销等任何违法兼职或犯罪活动的；仿冒、混淆他人账号昵称、头像、功能介绍或发布招聘内容等，或冒充、利用他人名义对外招聘的；为任何注册用户或非注册用户提供自动登录到本平台、代办或协助他人代办身份认证服务的或代售身份认证所需的相关材料或凭据等；任何导致或可能导致启航就业公司与第三方产生纠纷、争议或诉讼的行为。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 9.用户在启航就业上传或张贴的内容（包括但不限于照片、文字、面试经历及心得评价等），视为用户授予我们及其关联公司免费、非独家的使用权，启航就业有权为展示、传播及推广前述张贴内容的目的，对上述内容进行复制、修改、出版等。该使用权持续至用户书面通知到达我方后不得继续使用。因用户上传或张贴的内容侵犯他人权利，而导致任何第三方向我们提出侵权或索赔要求的，用户应承担全部责任。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 10.任何第三方对于用户在启航就业的公开使用区域张贴的内容进行复制、修改、编辑、传播等行为的，该行为产生的法律后果和责任均由行为人承担，与启航就业无关。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 11.用户同意不对我们提供的服务或服务的任何部分，进行复制、拷贝、出售、转售或用于任何其他商业目的。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 12.禁止通过职位向应聘者收费，否则，我们有权终止提供一切服务内容并封禁、注销该等违规账户，且将有关违法事实移交有关部门进行严正处理。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.1pt"} }, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createTextVNode("第七条 知识产权保护"),
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1))
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 1.启航就业尊重知识产权。除非获得作品作者或相关权利主体同意，启航就业不会擅自使用、修改、复制、公开传播、改变、散布、发行或公开发表他方拥有知识产权的作品或成果；根据法律法规规定有权使用的除外。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 2.任何组织或个人认为启航就业的内容可能侵犯其合法权益的，可向启航就业及经营公司提出异议，启航就业及经营公司将在收到权利人异议后，经核实确认后依法采取解决措施。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 3.启航就业"),
  /*#__PURE__*/_createElementVNode("span", null, "PC"),
  /*#__PURE__*/_createTextVNode("端、小程序、公众号上的内容，包括但不限于著作、图片、档案、资讯、资料、网站架构、网站画面的安排、网页设计等，均由启航就业及经营公司依法拥有知识产权，包括但不限于商标权、专利权、著作权、商业秘密等。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 4.非经启航就业及经营公司书面同意，不可擅自使用、修改、反向编译、复制、公开传播、改变、散布、发行或公开发表启航就业网站程序或内容，但依法合规分享除外。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 5.尊重知识产权是用户应尽的义务，如有违反，需承担相应的法律责任和赔偿责任。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.1pt"} }, [
  /*#__PURE__*/_createElementVNode("b", null, "第八条 启航就业管理措施")
], -1))
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 1.赔偿责任"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 如用户的行为造成启航就业及经营公司影响或损失（包括直接经济损失，商誉损失等间接经济损失，赔偿金，律师费、诉讼费等维权产生的费用）的，用户负有消除启航就业及经营公司影响并承担赔偿全部损失的责任。如用户的行为导致启航就业及经营公司被第三人主张权利的，启航就业及经营公司对第三人承担责任后有权向用户追偿全部损失。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 2.特别约定"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "1"),
  /*#__PURE__*/_createTextVNode("）如用户向启航就业及经营公司的员工或合作方或顾问等提供实物、现金、劳务、旅游等价值明显超出正常商务洽谈的，可视为用户存在商业贿赂行为。启航就业可立即依法处理。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "2"),
  /*#__PURE__*/_createTextVNode("）启航就业的所有用户在注册、使用启航就业平台时，禁止侵犯他人的姓名权、名称权等合法权利。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "3"),
  /*#__PURE__*/_createTextVNode("）账号使用与安全：账号由用户自行保管，严禁转借他人使用；如发现他人盗用，用户需及时告知平台，并及时在平台完成信息修改。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "4"),
  /*#__PURE__*/_createTextVNode("）用户如违反本协议规定的禁止情形，启航就业有权在不经任何事先通知的情况下暂停或终止向该用户提供服务。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "5"),
  /*#__PURE__*/_createTextVNode("）用户有下列行为或发布"),
  /*#__PURE__*/_createElementVNode("span", null, "/"),
  /*#__PURE__*/_createTextVNode("散布"),
  /*#__PURE__*/_createElementVNode("span", null, "/"),
  /*#__PURE__*/_createTextVNode("传播如下相关信息的，我们在发现或接到投诉并核实后，有权采取冻结账号、升级认证或以其他方式暂停向该用户提供服务，并要求用户承担相应的损害赔偿责任：涉及广告（寻求合作）、传销或直销等内容；涉及色情、淫秽内容；涉及违法"),
  /*#__PURE__*/_createElementVNode("span", null, "/"),
  /*#__PURE__*/_createTextVNode("政治敏感内容；虚假信息，包括但不限于不真实的企业信息、薪资、"),
  /*#__PURE__*/_createElementVNode("span", null, "BOSS"),
  /*#__PURE__*/_createTextVNode("身份、个人简历及求职信息、职位信息等；利用启航就业提供的服务索取他人隐私；涉及人身攻击或其他侵害他人权益的内容；未成年人工作信息；招聘他人从事违法活动；以培训费、服装费等名义骗取求职者财物；骚扰其他用户；以启航就业服务获取的个人信息，进行倒卖、披露或用于其他非招聘用途的；利用本平台可能存在的漏洞恶意充值虚拟产品或服务；涉嫌拖欠"),
  /*#__PURE__*/_createElementVNode("span", null, "/"),
  /*#__PURE__*/_createTextVNode("未按法律规定支付薪资"),
  /*#__PURE__*/_createElementVNode("span", null, "/"),
  /*#__PURE__*/_createTextVNode("劳务报酬的，或涉嫌具有其他可能损害劳动者或劳务人员合法权益的。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "6"),
  /*#__PURE__*/_createTextVNode("）涉及农民工或涉众的均属于“情节严重”，本平台有权对前述情形进行封禁账户的处置，相关判断方式包括但不限于因上述行为被列入相关政府部门“黑名单”、被多名用户举报投诉或被新闻媒体曝光等情形"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 若存在擅自将账号转让给他人使用或信息变更、泄露、账户被盗用等情形，由此产生的所有责任由用户自行承担。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.1pt"} }, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createTextVNode("第九条 关于面试聊天等即时通讯服务"),
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1))
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 1.用户在接受启航就业提供与启航就业注册用户或启航就业关联方用户进行提在线开聊、邀约面试等即时通讯服务时，应当遵守法律法规、社会主义制度、国家利益、公民合法权益、公序良俗、诚实守信等六条底线。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 2.用户通过本平台与他人在线开聊、拨打电话以及视频面试等商务场景下产生的文字、语音及视频等形式的沟通信息，我们将会根据法律规定暂时存储，且仅用于投诉举报的处理、安全风控及离线暂存功能的实现。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 3.我们对该等信息的采集、传输及存储均会采取加密、防泄露等相关措施。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 4.为保护其他用户隐私，您不得下载、传播或公开发布本条规定的其他用户通讯信息，如面试聊天记录等。如因此造成我们损失，或者侵害其他用户权益的，您应当承担违约责任或赔偿责任。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_184 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.1pt"} }, [
  /*#__PURE__*/_createElementVNode("b", null, "第十条 协议更新和修改")
], -1))
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 1.协议更新"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 根据国家法律法规修订情况及维护业务发展、保护用户权益的具体需要，启航就业可视情况更新本协议（如修改本协议、补充协议条款）。一旦发生变更，我们将在启航就业网站内进行更新及提示，或将最新版本的协议以系统消息、弹框或邮件的形式发送给用户阅读及确认接收。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_187 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 2.用户如果不同意条款的修改，应主动停止使用启航就业或申请注销启航就业账号，停止使用后，用户承诺启航就业仍有权继续保留用户的用户信息。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 3.协议更新后，用户继续使用启航就业服务的，视为对更新协议的认可。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.1pt"} }, [
  /*#__PURE__*/_createElementVNode("b", null, "第十一条 不可抗力、免责及责任限制")
], -1))
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 1.免责条款"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_191 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 因下列原因导致启航就业无法正常提供服务的，可能会导致启航就业无法访问、访问速度缓慢、存储数据丢失、用户个人信息泄漏等不利后果。启航就业及经营公司不承担任何责任："),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "1"),
  /*#__PURE__*/_createTextVNode("）启航就业系统停机维护或升级；"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_193 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "2"),
  /*#__PURE__*/_createTextVNode("）台风、地震、洪水、雷电或恐怖袭击、流行性传染病、政府政策及行为等不可抗力原因；"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "3"),
  /*#__PURE__*/_createTextVNode("）用户的电脑软硬件和通信线路、供电线路出现故障的；"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_195 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "4"),
  /*#__PURE__*/_createTextVNode("）因用户操作不当或通过非经平台授权或认可的方式使用服务的；"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_196 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "5"),
  /*#__PURE__*/_createTextVNode("）因病毒、网络程序攻击、网络拥堵、系统不稳定、系统或设备故障、通讯故障、电力故障、银行原因、第三方服务瑕疵或政府政策、行为等原因；"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" （"),
  /*#__PURE__*/_createElementVNode("span", null, "6"),
  /*#__PURE__*/_createTextVNode("）其他原因。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_198 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 2.发生前款情形的，遭受不可抗力事件时，我们可中止履行本协议项下的义务直至不可抗力的影响消除为止，并且不因此承担违约责任；但应尽最大努力克服该事件，减轻其负面影响。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_199 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.1pt"} }, [
  /*#__PURE__*/_createElementVNode("b", null, "第十二条 隐私政策")
], -1))
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 启航就业依法保护用户个人信息和隐私信息。有关隐私政策的内容，详见启航就业《用户信息及隐私权规定》。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.1pt"} }, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createTextVNode("第十三条 启航就业通知送达"),
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1))
const _hoisted_202 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 启航就业可通过平台页面公告、用户个人中心的短信、电话、系统消息等方式通知用户，通知在发送成功后即视为送达。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_203 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 如果用户在启航就业上发生纠纷的，司法机关可通过本协议规定的通知方式向用户送达相应法律文书。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_204 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.1pt"} }, [
  /*#__PURE__*/_createElementVNode("b", null, "第十四条 法律适用与管辖")
], -1))
const _hoisted_205 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 有关本服务协议条款的效力、解释、变更、执行与争议解决均适用中华人民共和国法律。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_206 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 因履行本服务协议条款产生争议的，双方应友好协商，协商不能解决的，可以提交平台方协商处理；若无法协商处理的，则向昆明仲裁委员会申请仲裁。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.1pt"} }, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createTextVNode("第十五条 其他"),
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1))
const _hoisted_208 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 1.启航就业经营公司对协议以及基于本协议制定的各项协议、提示等拥有最终解释权。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_209 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createTextVNode(" 2.如对协议内容有任何疑问、意见或建议，您可通过启航就业客服电话"),
  /*#__PURE__*/_createElementVNode("span", null, "  "),
  /*#__PURE__*/_createTextVNode("或邮箱："),
  /*#__PURE__*/_createElementVNode("span", null, "      "),
  /*#__PURE__*/_createTextVNode("与平台联系。"),
  /*#__PURE__*/_createElementVNode("span")
], -1))
const _hoisted_210 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"text-indent":"28.0pt"} }, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_211 = [
  _hoisted_105,
  _hoisted_106,
  _hoisted_107,
  _hoisted_108,
  _hoisted_109,
  _hoisted_110,
  _hoisted_111,
  _hoisted_112,
  _hoisted_113,
  _hoisted_114,
  _hoisted_115,
  _hoisted_116,
  _hoisted_117,
  _hoisted_118,
  _hoisted_119,
  _hoisted_120,
  _hoisted_121,
  _hoisted_122,
  _hoisted_123,
  _hoisted_124,
  _hoisted_125,
  _hoisted_126,
  _hoisted_127,
  _hoisted_128,
  _hoisted_129,
  _hoisted_130,
  _hoisted_131,
  _hoisted_132,
  _hoisted_133,
  _hoisted_134,
  _hoisted_135,
  _hoisted_136,
  _hoisted_137,
  _hoisted_138,
  _hoisted_139,
  _hoisted_140,
  _hoisted_141,
  _hoisted_142,
  _hoisted_143,
  _hoisted_144,
  _hoisted_145,
  _hoisted_146,
  _hoisted_147,
  _hoisted_148,
  _hoisted_149,
  _hoisted_150,
  _hoisted_151,
  _hoisted_152,
  _hoisted_153,
  _hoisted_154,
  _hoisted_155,
  _hoisted_156,
  _hoisted_157,
  _hoisted_158,
  _hoisted_159,
  _hoisted_160,
  _hoisted_161,
  _hoisted_162,
  _hoisted_163,
  _hoisted_164,
  _hoisted_165,
  _hoisted_166,
  _hoisted_167,
  _hoisted_168,
  _hoisted_169,
  _hoisted_170,
  _hoisted_171,
  _hoisted_172,
  _hoisted_173,
  _hoisted_174,
  _hoisted_175,
  _hoisted_176,
  _hoisted_177,
  _hoisted_178,
  _hoisted_179,
  _hoisted_180,
  _hoisted_181,
  _hoisted_182,
  _hoisted_183,
  _hoisted_184,
  _hoisted_185,
  _hoisted_186,
  _hoisted_187,
  _hoisted_188,
  _hoisted_189,
  _hoisted_190,
  _hoisted_191,
  _hoisted_192,
  _hoisted_193,
  _hoisted_194,
  _hoisted_195,
  _hoisted_196,
  _hoisted_197,
  _hoisted_198,
  _hoisted_199,
  _hoisted_200,
  _hoisted_201,
  _hoisted_202,
  _hoisted_203,
  _hoisted_204,
  _hoisted_205,
  _hoisted_206,
  _hoisted_207,
  _hoisted_208,
  _hoisted_209,
  _hoisted_210
]
const _hoisted_212 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("pre", {
  class: "preline lh30 fbold",
  style: {"font-family":"fangsong"}
}, "      云南启航就业服务平台职位信息发布规则\n亲爱的云南启航就业服务平台（以下简称“启航就业”）用户（以下简称“用户”或“您”），在您注册后，有权通过注册招聘账号，成为启航就业注册招聘用户，享受启航就业提供的发布职位信息的针对性服务。为了保障您的相关合法权益，在您拟注册成为启航就业注册招聘用户并发布职位信息时，须先审慎阅读本规则，充分了解本规则关于启航就业发布职位信息的注意事项，严格按本规则发布职位信息。\n您一旦点击已阅读知晓选项，并开始使用本平台服务，即表示您已经确认并接受了本规则项下的全部条款，本规则自您点击确认之时起即生效，届时本规则将完整约束您使用本平台关于发布信息规则的行为，对于您未来可能出现的违反本协议项下约定的所有情形，您将按照本协议有关条款承担不利后果及法律责任。\n第一条 概述\n1.本规则全面约定了平台关于职位信息发布服务的具体规则，明确了职位信息发布的内容草拟、行为界定等内容。\n2.《云南启航就业服务平台职位信息发布规则》（以下简称“本规则”）系您（指个人或组织）使用启航就业发布招聘信息的规定，系启航就业规则体系之一，对用户有约束力。\n3.您在使用启航就业发布职位信息服务之前，请务必审慎阅读、充分理解本规则。您使用启航就业平台职位信息发布服务的行为，即表示您已阅读并同意本规则所涉全部内容。\n4.启航就业有权根据法律法规、政策及服务需求更新本规则，届时将通过。如您继续使用启航就业服务的，即表示您接受经修订后的规则。\n第二条 职位信息发布基本规则\n1.用户发布职位信息等，须确保填写的主体相关信息、职位信息等招聘信息合法、真实、准确，您发布的所有文字、图片、视频等内容，都不得含有任何违法、政治敏感、不符合公序良俗、侵犯他人权益等违法违规的内容。\n2.主体、职位信息等均不得违反《中华人民共和国民法典》《中华人民共和国劳动法》《中华人民共和国劳动合同法》等法律法规。\n3.信息发布主体的主体信息明确、真实、有效，且不得侵犯任何第三人的合法权益，包括但不限于发布主体的名称（姓名）、LOGO、品牌。\n4.公司网址、招聘网址应当真实有效，如发生变化应当及时更新。\n5.发布的招聘信息须合法、合规、真实、准确、完整，便于求职者理解，不得发布与主体招聘无关的内容。\n6.在主体页面上，不得上传与招聘主体无关的图片或涉及联系方式等其他无关或误导求职用户的内容。\n7.用户（公司）介绍中包含的经营内容应当与公司的经营范围存在一致性。\n8.职位信息等介绍应当真实、准确、完整，不得存在侵犯第三人合法权益的内容。\n9.若上传图片，则应当真实可辨，不得将无关的图片上传。\n10.发布者应知晓发布信息具有法律约束力，发布的信息须客观真实，不得存在夸大、引诱、欺骗、不正当竞争、虚假承诺等内容或行为。\n11.发布的信息中不得包含任何其他个人的隐私信息或其他公司/个人的商业信息。\n第三条 禁止发布的职位信息\n1.法律法规禁止的信息；\n包括但不限于违反《中华人民共和国劳动合同法》等相关法律法规规定的内容，如低于最低工资标准要求等；性别歧视或指向性歧视、地域歧视等。\n2.违法、违背公序良俗的信息\n包含色情、淫秽、性暗示或三俗内容，如寻找伴侣、寻求包养、涉及陪酒类的职位等。\n3.包含违法、政治敏感内容；\n4.包含侵害他人权益的内容；\n5.虚假/不明确的主体信息、职位信息；\n6.虚假的职位描述、工作内容、薪资或工作地点；\n7.职位类型与职位描述或与公司经营范围不符的；\n8.一个岗位发布多个职位或重复发布相同职位情节严重的；\n9.发布的职位信息与实际所招聘职位不符；\n10.包含广告、寻求合作、传销、直销等与招聘无关内容；\n11.违规或高风险类信息；\n12.涉及套路贷类职位；\n13.演员、练习生、歌手类职位；\n14.夜场等娱乐会所类职位；\n15.工作地点不在中国境内；\n16.信用卡套现类职位；\n17.淘宝刷单、微商代理、手机兼职、手工兼职类职位；\n18.游戏代练类职位；\n19.涉及发布代孕、捐精、捐卵业务；\n20.涉及陪玩、陪聊、恶意招聘大量（5个以上）兼职主播的职位；\n21.挂靠类职位；\n22.兼职推广或为其他平台拉用户的职位；\n23.有涉黄倾向的模特类的职位；\n24.涉及违规网约车司机、送餐员/外卖骑手的职位；\n25.涉及体验师类的职位（含兼职），例如旅游体验师等；\n26.其他存在高风险及不符合国家法律法规政策的职位。\n第四条 禁止实施的行为\n本平台严禁用户利用启航就业服务，在发布、聊天、邀约或线上面试等各项环节，实施下述行为。如您/您的关联账号存在下述行为，您的职位信息（免费、付费）均有可能无法审核通过或被删除/屏蔽；您的账号可能被暂时或永久冻结：\n1.实施任何辱党、辱国、传播邪教思想等违法及违背公序良俗的行为；\n2.在平台内违法使用涉及各国政治人物的图片；\n3.在平台内使用含色情、淫秽内容的图片；\n4.在平台内使用人身攻击或其他侵害他人权益的图片；\n5.通过非启航就业开发、授权的第三方软件、插件、外挂或系统或其他不正常的方式，登录、使用启航就业平台服务，影响或可能影响启航就业平台管理运营秩序的；\n6.以培训费、服装费、工作需要等任何名义向求职者索要财物、收取求职者费用、引导求职者贷款、引导求职者入金等；\n7.实施传销活动或骗取他人加入传销组织；\n8.招聘他人从事违法违规、违背公序良俗的活动，包括但不限于学术造假、作弊、替考、刷单、赌博等；\n9.直接或变相索取其他用户个人信息的行为，包括但不限于扣押身份证等证件；\n10.骚扰其他用户；\n11.以招聘名义招人培训；\n12.所招聘岗位无薪资或存在涉及拒发或恶意拖欠工资的行为；\n13.招聘未满18周岁人员（年满16周岁未满18周岁的未成年人如果以自己的劳动收入为主要的生活来源除外，且从事的劳动需符合法律法规的规定）；\n14.发布涉及违规网约车司机、违规送餐员/外卖骑手等相关信息的行为；\n15.未通过平台功能与用户交换联系方式或诱导用户站外求职招聘，例如发送包含社交账号/通信方式（例如微信号/QQ号/手机号/第三方网站链接等）的聊天信息、发布包含前述内容的职位；\n16.其他违反法律法规、违背公序良俗、对抗平台规则、破坏平台秩序等不当行为。\n第五条 暂不提供服务的主体类型\n基于合法性、安全性、真实性、效率性及产品政策等原因，本平台暂不为存在以下情况的公司提供职位发布服务。因此，您可能无法发布此类主体的介绍信息，无法发布相关的职位信息，或/和该信息在发布后被平台驳回/删除/屏蔽：\n1.所招聘岗位无薪资或公司存在涉及拒发或恶意拖欠工资的主体\n2.涉及以招聘名义招人培训的主体\n3.存在刷单、微商代理、手机兼职、手工兼职业务的主体\n4.存在跟剧组行为的主体\n5.存在兼职模特、试衣模特业务的主体\n6.存在培养演员、练习生、歌手业务的主体\n7.存在需要求职者去境外工作的主体\n8.主营业务为夜场等娱乐场所的主体\n9.涉及收取求职者费用、引导求职者贷款、引导求职者入金的主体\n10.涉及色情、淫秽、性暗示或三俗内容的主体\n11.存在直销或传销模式业务的主体\n12.存在信用卡套现的主体\n13.存在挂靠业务的主体\n14.存在涉及套路贷业务的主体\n15.在国家企业信用信息公示系统中的登记状态为注销/吊销状态的主体\n16.在国家企业信用信息公示系统中被列入经营异常名录，情节严重的主体\n17.在国家企业信用信息公示系统中查询不到注册信息的主体\n18.已被法院判定为破产或正在进行破产申请流程的主体\n19.在媒体、网站或社交平台等渠道中查询到涉嫌存在严重失信、违法违规或违反平台规则等相关行为的主体\n20.被多位用户举报的主体\n21.涉及代孕、捐精、捐卵的业务的主体\n22.涉及陪玩、陪聊、恶意招聘大量兼职主播的主体\n23.涉及招聘无经验交易员、分析师的主体\n24.涉及保险业务的主体（除内测用户以外）\n25.存在涉及虚拟/数字货币交易的主体\n26.涉及兼职推广或为其他平台拉用户等业务的主体\n27.涉嫌从事网络发行、销售彩票相关业务的主体\n28.涉嫌非法经营或从事违法违规、违背公序良俗业务的主体\n29.发布模特职位且有涉黄倾向的主体\n30.发布违规网约车司机、送餐员/外卖骑手职位的主体\n31.发布涉及体验师类职位（含兼职）的主体，例如旅游体验师等\n32.发布涉及出海类职位的主体，例如船员、出海捕捞岗位等\n33.发布涉及陪酒类职位的主体\n34.其他基于风控策略/安全风险/产品政策等原因无法提供服务的主体\n第六条 违约处理\n1.对违反法律法规及本规则相关规定得主体构成违约，启航就业有权采取相关手段予以处理。\n2.启航就业有权对用户发布的主体信息、职位信息进行审核，对于不符合本规则的内容，有权采取拒绝发布、部分或全部删除等处理措施。\n3.您或您的关联账号用户违反前述规定的内容，或者有其他可能损害启航就业利益或第三人利益，存在违法行为的，启航就业有权视情节采取，包括但不限于冻结您的账户的方式暂时乃至永久停止您使用启航就业服务且不做解封与退款处理、禁言、限制部分或全部功能的使用、取消预约面试等相关处理措施。\n4.如用户行为涉嫌违法犯罪的，启航就业有权向有关行政机关及司法部门举报、披露相关信息。\n5.如您的行为给启航就业及关联主体造成损失的，启航就业及关联主体有权要求您赔偿全部的损失；\n6.为防止信息泄露，保障启航就业平台的稳定及安全，任何用户不得使用任何相关招聘管理系统/插件/外挂/工具，访问或接入启航就业系统及/或获取启航就业免费及付费服务，同时，用户不得制作、发布、传播上述插件/外挂/工具，无论以任何目的。\n7.用户违反本规则的，本平台可以依据本规则直接采取相关措施，并视情节严重程度选择是否通知用户。接到通知的用户可以通过启航就业公布得渠道向本平台提交申诉。\n第七条 隐私政策\n启航就业依法保护用户个人信息和隐私信息。有关隐私政策的内容，详见启航就业《用户信息及隐私权规定》。\n第八条 启航就业通知送达\n1.启航就业可通过平台页面公告、用户个人中心的短信、电话、系统消息等方式通知用户，通知在发送成功后即视为送达。\n2.如果用户在启航就业上发生纠纷的，司法机关可通过本协议规定的通知方式向用户送达相应法律文书。\n第九条 法律适用与管辖\n1.有关本规则条款的效力、解释、变更、执行与争议解决均适用中华人民共和国法律。\n2.因履行本规则条款产生争议的，双方应友好协商，协商不能解决的，可以提交平台方协商处理；若无法协商处理的，则向昆明仲裁委员会申请仲裁。\n第十条 其他\n1.启航就业平台及经营公司对本规则拥有最终解释权。\n2.如对规则内容有任何疑问、意见或建议，您可通过启航就业客服电话4008061633或邮箱：a4008061633@163.com与平台联系。\n    ", -1))
const _hoisted_213 = [
  _hoisted_212
]
const _hoisted_214 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("pre", {
  class: "preline lh30 fbold",
  style: {"font-family":"fangsong"}
}, "        一、前言\n        感谢您使用就业彩云南平台！为打造一个合法、安全、公平、真实、准确、效率的招聘求职信息服务平台，我们对就业彩云南职位信息制定了基本的规则。\n        本《就业彩云南职位信息发布规则》（以下简称“规则”）系您（指个人或组织）与北京华品博睿网络技术有限公司（以下简称“就业彩云南公司”或“本平台”）订立的《就业彩云南用户协议》的有效组成部分，与《就业彩云南用户协议》共同构成您与就业彩云南公司合作的法律文件。\n        您在使用就业彩云南软件填写并发布企业信息、职位信息之前，请务必审慎阅读、充分理解本规则。您使用就业彩云南平台职位信息发布服务的行为，即表示您已阅读并同意本规则所涉全部内容。\n        就业彩云南有权根据法律法规、政策及产品需求更新本规则，请您定期访问并查看最新规则。如您继续使用就业彩云南服务的，即表示您接受经修订后的规则。\n        二、企业信息发布规则\n        您应当确保填写的企业相关信息合法、真实、准确，您发布的所有文字、图片、视频等内容，都不得含有任何违法、政治敏感、不符合公序良俗、侵犯他人权益的内容。\n        在您填写或修改已有的企业相关信息时，应当遵守的具体规则包括但不限于：\n        1.企业名称、品牌名称、LOGO应当真实有效；品牌名称、LOGO应当与该企业主体具有一致性，或有使用权\n        2.品牌名称不得与其他知名品牌名称相同或近似\n        3.公司LOGO应当与公司经营过程中实际使用的LOGO一致，且与其他品牌的使用在先的LOGO不相同或近似\n        4.公司经营地址应当真实有效，如发生变化应当及时更新\n        5.公司网址应当真实有效，如发生变化应当及时更新\n        6.在公司介绍主页上，不得上传与公司无关的图片或涉及联系方式的内容\n        7.公司介绍的文字内容应当真实、准确、完整，便于求职者理解，不得发布与公司介绍无关的文字内容\n        8.公司介绍中包含的经营内容应当与公司的经营范围存在一致性\n        9.产品介绍应当真实、准确、完整，不得将他人产品或产品介绍挪为己用，相关产品应符合公司的经营范围要求\n        10.提供的高管或个人图片应当真实可辨，不得将他人的照片或无关的图片作为高管照片或个人照片\n        11.您发布的信息中不得包含任何其他个人的隐私信息或其他公司的商业信息\n        三、禁止发布的职位信息\n        基于合法性、安全性、真实性、有效性等原则考虑，目前就业彩云南平台不提供包含以下信息的职位发布服务，若您发布的职位信息包含以下内容，可能将随时被驳回（部分或全部屏蔽、删除）：\n        违法及不良类信息 1.包含违法、政治敏感内容\n        2.包含色情、淫秽、性暗示或三俗内容，如寻找伴侣、寻求包养等\n        3.包含违反《劳动合同法》等相关法律法规规定的内容，如低于最低工资要求等\n        4.包含性别歧视或指向性歧视、地域歧视等\n        5.包含人身攻击或其他侵害他人权益的内容 虚假/不明确的信息\n        6.包含不真实的公司信息 7.包含虚假的身份信息\n        8.包含不真实的职位描述、工作内容、薪资或工作地点\n        9.职位类型与职位描述或与公司经营范围不符的 10.职位名称与职位描述不明确的\n        11.职位名称包含职位名称以外信息的\n        12.一个岗位发布多个职位或重复发布相同职位情节严重的\n        13.发布的职位信息与实际所招聘职位不符\n        14.包含广告、寻求合作、传销、直销等内容\n        15.包含微信号、QQ号、手机号等第三方社交账号(或链接)内容\n        16.包含鸡汤、段子、水贴等与招聘无关的信息 违规或高风险类信息\n        17.兼职模特、试衣模特类职位 18.无经验交易员、分析师类职位\n        19.涉及套路贷类职位 20.跟剧组类职位 21.演员、练习生、歌手类职位\n        22.夜场等娱乐会所类职位 23.涉及出海类的职位，如船员、出海捕捞岗位等\n        24.工作地点不在中国境内 25.涉及异地培训/实习的保安类职位\n        26.信用卡套现类职位 27.淘宝刷单、微商代理、手机兼职、手工兼职类职位\n        28.游戏代练类职位 29.涉及发布代孕、捐精、捐卵业务\n        30.涉及陪玩、陪聊、恶意招聘大量（5个以上）兼职主播的职位 31.挂靠类职位\n        32.部分涉及保险业务的职位（内测用户除外）\n        33.兼职推广或为其他平台拉用户的职位 34.涉及网络发行、销售彩票类职位\n        35.有涉黄倾向的模特类的职位 36.涉及违规网约车司机、送餐员/外卖骑手的职位\n        37.被多位用户举报的职位\n        38.涉及体验师类的职位（含兼职），例如旅游体验师等 39.涉及陪酒类的职位\n        40.其他存在高风险及不符合产品政策的职位 四、禁止实施的行为\n        本平台严禁用户利用就业彩云南服务，在发布、开聊、邀约或线上面试等各项环节，实施下述行为。如您/您的关联账号存在下述行为，您的职位信息（免费、付费）均有可能无法审核通过或被删除/屏蔽；您的账号可能被暂时或永久冻结：\n        1.实施任何辱党、辱国、传播邪教思想等违法及违背公序良俗的行为\n        2.在平台内使用涉及各国政治人物的图片\n        3.在平台内使用含色情、淫秽内容的图片\n        4.在平台内使用人身攻击或其他侵害他人权益的图片\n        5.通过非就业彩云南开发、授权的第三方软件、插件、外挂或系统或其他不正常的方式，登录、使用就业彩云南平台服务，影响或可能影响就业彩云南平台管理运营秩序的\n        6.以培训费、服装费、工作需要等任何名义向求职者索要财物、收取求职者费用、引导求职者贷款、引导求职者入金等\n        7.实施传销活动或骗取他人加入传销组织\n        8.招聘他人从事违法违规、违背公序良俗的活动，包括但不限于学术造假、作弊、替考、刷单、赌博等\n        9.直接或变相索取其他用户个人信息的行为 10.骚扰其他用户\n        11.利用平台可能存在的漏洞进行“撸羊毛”、恶意充值“直豆”/获取“搜索畅聊卡”等道具产品、在第三方售卖前述道具产品\n        12.在平台内使用涉及广告（寻求合作）、营销的头像或宣传图片\n        13.无RPO业务但帮其他公司招聘的行为 14.以招聘名义招人培训\n        15.个体工商户发布异地职位的行为\n        16.所招聘岗位无薪资或存在涉及拒发或恶意拖欠工资的行为\n        17.招聘未满16周岁人员\n        18.发布涉及违规网约车司机、违规送餐员/外卖骑手等相关信息的行为\n        19.未通过平台功能与用户交换联系方式或诱导用户站外求职招聘，例如发送包含社交账号/通信方式（例如微信号/QQ号/手机号/第三方网站链接等）的开聊信息、发布包含前述内容的职位\n        20.其他违反法律法规、违背公序良俗、对抗平台规则、破坏平台秩序等不当行为\n        五、暂不提供服务的企业类型\n        基于合法性、安全性、真实性、效率性及产品政策等原因，本平台暂不为存在以下情况的公司提供职位发布服务。因此，您可能无法发布此类公司的介绍信息，无法发布相关的职位信息，或/和该信息在发布后被平台驳回/删除/屏蔽：\n        1.所招聘岗位无薪资或公司存在涉及拒发或恶意拖欠工资的公司\n        2.涉及以招聘名义招人培训的公司\n        3.存在刷单、微商代理、手机兼职、手工兼职业务的公司\n        4.存在跟剧组行为的公司 5.存在兼职模特、试衣模特业务的公司\n        6.存在培养演员、练习生、歌手业务的公司 7.存在需要求职者去境外工作的公司\n        8.主营业务为夜场等娱乐场所的公司\n        9.涉及收取求职者费用、引导求职者贷款、引导求职者入金的公司\n        10.涉及色情、淫秽、性暗示或三俗内容的公司\n        11.存在直销或传销模式业务的公司 12.存在信用卡套现的公司\n        13.存在挂靠业务的公司 14.存在涉及套路贷业务的公司\n        15.在国家企业信用信息公示系统中的登记状态为注销/吊销状态的公司\n        16.在国家企业信用信息公示系统中被列入经营异常名录，情节严重的公司\n        17.在国家企业信用信息公示系统中查询不到注册信息的公司\n        18.已被法院判定为破产或正在进行破产申请流程的公司\n        19.在媒体、网站或社交平台等渠道中查询到涉嫌存在严重失信、违法违规或违反平台规则（指您与就业彩云南公司签署的包括但不限于《就业彩云南用户协议》《增值服务协议》及本规则）等相关行为的公司\n        20.被多位用户举报的公司 21.涉及代孕、捐精、捐卵的业务的公司\n        22.涉及陪玩、陪聊、恶意招聘大量兼职主播的公司\n        23.涉及招聘无经验交易员、分析师的公司\n        24.涉及猎头业务、招聘流程外包等人力资源服务或为第三方招聘的公司（人才经纪人除外）\n        25.涉及保险业务的公司（除内测用户以外）\n        26.存在涉及虚拟/数字货币交易的公司\n        27.涉及兼职推广或为其他平台拉用户等业务的公司\n        28.涉嫌从事网络发行、销售彩票相关业务的公司\n        29.涉嫌非法经营或从事违法违规、违背公序良俗业务的公司\n        30.发布模特职位且有涉黄倾向的公司 31.发布异地培训/实习的保安职位的公司\n        32.发布违规网约车司机、送餐员/外卖骑手职位的公司\n        33.发布涉及体验师类职位（含兼职）的公司，例如旅游体验师等\n        34.发布涉及出海类职位的公司，例如船员、出海捕捞岗位等\n        35.发布涉及陪酒类职位的公司\n        36.其他基于风控策略/安全风险/产品政策等原因无法提供服务的公司\n        六、违规处罚规则\n        1.本平台有权对用户发布的企业信息、职位信息进行审核，对于不符合本规则的内容，有权采取拒绝发布、部分或全部删除等处理措施。\n        2.用户违反前述第二条、第三条、第四条规定的内容，或者有其他可能损害就业彩云南利益或违法行为的，就业彩云南公司有权视情节采取，包括但不限于冻结您的账户的方式暂时乃至永久停止您使用就业彩云南服务且不做解封与退款处理、禁言、限制部分或全部功能的使用、取消预约面试等相关处理措施。如用户行为涉嫌违法犯罪的，就业彩云南有权向有关行政机关及司法部门举报、披露相关信息。\n        3.您或您的关联账号涉嫌违反本规则，或者有其他明显损害就业彩云南公司利益或违法行为的，经本平台发现或用户投诉后核实的，就业彩云南公司有权视情节采取冻结账户的方式暂时乃至永久停止您使用就业彩云南服务且不做解封与退款处理。\n        4.如您的行为给就业彩云南公司造成损失的，就业彩云南公司有权要求您赔偿全部的损失；如涉嫌违法犯罪的，就业彩云南公司有权向有关行政机关及司法部门举报、披露相关信息。\n        5.如企业违反本规则的情节严重的，就业彩云南公司有权冻结该企业，即不为该企业提供相关服务。\n        6.为防止信息泄露，保障就业彩云南平台的稳定及安全，任何用户不得使用任何相关招聘管理系统/插件/外挂/工具/ATS，包括但不限于北森、大易、moka、图谱、云招、e成等，访问或接入就业彩云南系统及/或获取就业彩云南免费及付费服务（包括但不限于登录就业彩云南账号、发布职位、浏览职位、收发简历、筛选匹配、定向推送消息、自动沟通等）同时，用户不得制作、发布、传播上述插件/外挂/工具，无论以任何目的。\n        7.用户违反本规则的，本平台可以依据本规则直接采取相关措施，并视情节严重程度选择是否通知用户。接到通知的用户可以通过“锁定通知”页面显示的渠道向本平台提交申诉。\n        8.就业彩云南账号与店长直聘账号的所有者为同一用户的，如该用户的一个账号被冻结，另一帐号将被同时冻结。\n        9.两个用户名下认证的账号，被系统判定是关联账号的，如其中一个账号因违法违规被冻结的，其他关联账号均将被同时冻结。\n        七、其他规则 1.定义： \n        o本规则所称“异地职位”指工作地点与招聘主体（指认证的企业）营业执照地址不一致或不在同一城市的招聘信息。\n        o本规则所称“违规网约车司机、送餐员/外卖骑手类职位”指无经营许可，擅自从事或者变相从事网约车平台、外卖平台或其他类似业务的招聘用户，发布涉及招聘网约车司机、送餐员/外卖骑手的职位信息。\n        o本规则所称“安保服务”指包括但不限于《保安服务管理条例》规定的从事门卫、巡逻、守护、押运、随身护卫等安全防范的工作，或提供安全检查/安全技术防范/安全风险评估/秩序维护等服务。\n        2.所有职位均设置了有效期限，本平台有权对不同的职位类别下职位信息设置不同的有效期，有效期届满时该职位信息可能被下线。\n        3.本平台有权根据法律法规、政策及产品需求更新本规则，并在平台内予以公布。新的规则自公布之日起生效。\n      ", -1))
const _hoisted_215 = [
  _hoisted_214
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogVisibleTF,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogVisibleTF) = $event)),
    width: "66%",
    onClose: _ctx.closeHandler
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, _hoisted_103, 512), [
        [_vShow, _ctx.type ==='U']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_104, _hoisted_211, 512), [
        [_vShow, _ctx.type ==='S']
      ]),
      _withDirectives(_createElementVNode("div", null, _hoisted_213, 512), [
        [_vShow, _ctx.type ==='P']
      ]),
      _withDirectives(_createElementVNode("div", null, _hoisted_215, 512), [
        [_vShow, _ctx.type ==='C']
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onClose"]))
}